import axios from 'axios';

const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];
const MAX_SELECT_BYTES = 6 * 1024 * 1024;
const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

export function emptyTravelUploadState() {
  return { file: null, loading: false, done: false };
}

export function validateTravelUploadFile(file) {
  if (!file) return { valid: false, message: 'No file selected' };
  if (file.size > MAX_SELECT_BYTES) {
    return { valid: false, message: 'File exceeds 6 MB limit' };
  }
  if (!ALLOWED_TYPES.includes(file.type)) {
    return { valid: false, message: 'Only PDF, JPEG, PNG files allowed' };
  }
  return { valid: true };
}

/**
 * Upload a travel passport copy — same endpoint as motor / legacy travel ExpressUpload.
 */
export async function uploadTravelPassport({
  file,
  fullName,
  email,
  phoneNumber,
  passportNumber,
  idNumber,
  kraPin,
  travelType = 'pacis',
}) {
  if (!file || file.size > MAX_UPLOAD_BYTES) {
    throw new Error('Passport file exceeds 10 MB limit');
  }

  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(/,(.+)/.exec(reader.result)[1]);
    reader.onerror = () => reject(new Error('FileReader failed'));
    reader.readAsDataURL(file);
  });

  const payload = {
    fileName: file.name,
    kraPinNumber: kraPin || passportNumber || idNumber || '',
    idNumber: idNumber || passportNumber || '',
    img64: base64,
    bucket: 'travel-policies',
    phoneNumber: phoneNumber || '',
    email: email || '',
    fullName: fullName || '',
    documentType: 'passport',
    travelType,
  };

  await axios.post('/customer/quotation/upload', payload, {
    timeout: 60000,
    _skipErrorRedirect: true,
  });
}
